import { Button, Tooltip } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { getProps } from "./ToggleSpeaker.utilities";
import { ToggleSpeakersProps } from "./ToggleSpeakers.decl";

export function ToggleSpeakers({ mode, setMode }: ToggleSpeakersProps) {
  const { t } = useTranslation();

  const isKaraoke = mode === "karaoke";
  const { icon: Icon, tooltip } = getProps(isKaraoke);

  const handleOnClick = () => {
    if (isKaraoke) {
      setMode("simple");
    } else {
      setMode("karaoke");
    }
  };
  const dataTest = `toggle-speakers-button-${isKaraoke ? "collapse" : "expand"}`;

  return (
    <Tooltip title={t(tooltip)}>
      <Button
        onClick={handleOnClick}
        size="small"
        data-test={dataTest}
        mode="ghost"
        variant="secondary"
      >
        <Icon />
      </Button>
    </Tooltip>
  );
}
